export const AVATAR_PALETTE = [
  { bg: '#dbeafe', fg: '#1d4ed8' },
  { bg: '#dcfce7', fg: '#166534' },
  { bg: '#fde8d4', fg: '#9a3412' },
  { bg: '#ede9fe', fg: '#6d28d9' },
  { bg: '#fef9c3', fg: '#854d0e' },
  { bg: '#fce7f3', fg: '#9d174d' }
];

export const avatarPalette = (name) =>
  AVATAR_PALETTE[(name || '').charCodeAt(0) % AVATAR_PALETTE.length];
